export default (score) => Math.floor(score / 20);
